import { Skeleton } from "@/components/ui/skeleton";

/** Generic page-level placeholder - used both for data-loading (QueryState) and route-chunk-loading (Suspense) waits. */
export function PageSkeleton() {
  return (
    <div className="space-y-2">
      <Skeleton className="h-8 w-48" />
      <Skeleton className="h-64 w-full" />
    </div>
  );
}
